<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <!-- Add Cart Modal -->
    <modal id="addCartModal" v-if="selectedArticle">
      <div slot="body" class="modal-body add-cart-box text-center">
        <p class="html-content" v-html="translations.addToCartSuccessMessage"></p>
        <h4 id="productTitle">
          {{ selectedArticle.title }}
        </h4>
        <img
          :src="`${baseUrl}${selectedArticle.highlightedImageUrl}`"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
        />
        <div class="btn-actions">
          <router-link :to="{ name: 'ShoppingCart' }" data-dismiss="modal">
            <button class="btn-primary">{{translations.goToShoppingCart}}</button>
          </router-link>
          <button class="btn-primary" data-dismiss="modal">
            {{translations.continueShopping}}
          </button>
        </div>
      </div>
    </modal>
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.id" />
      </div>
    </modal>
    <div class="container">
      <div class="row">
        <div class="col-lg-9 col-xl-5col-4">
          <nav class="toolbox mb-4 row">
            <div class="col-12 col-sm-6 d-flex">
              <div class="toolbox-item toolbox-sort">
                <div class="select-custom">
                  <select
                    name="orderby"
                    class="form-control"
                    v-model="sortField"
                    @change="handleSortChange"
                  >
                    <option :value="item.id" v-for="item in sortFields" :key="item.id">
                      {{ translations[item.label] }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="toolbox-item toolbox-sort">
                <div class="select-custom">
                  <select
                    class="form-control"
                    name="results-per-page"
                    v-model="searchConfig.pageSize"
                    @change="changePageSize(searchConfig.pageSize)"
                  >
                    <option :value="page" v-for="page in pageSizeList" :key="page">
                      {{ page }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- End .toolbox-item -->
            </div>
            <!-- End .toolbox-left -->
            <div
              class="col-12 col-sm-6 justify-content-between
              justify-content-md-end align-items-center d-flex"
            >
              <label class="d-flex d-sm-none d-md-flex">{{ paginationResultsTitle }}</label>
              <div class="layout-modes d-none d-md-flex justify-content-end">
                <div
                  class="layout-btn btn-grid"
                  title="Grid"
                  :class="{ active: layout === 'grid' }"
                  @click="layout = 'grid'"
                >
                  <i class="fa fa-th"></i>
                </div>
                <div
                  class="layout-btn btn-list"
                  title="List"
                  :class="{ active: layout === 'list' }"
                  @click="layout = 'list'"
                >
                  <i class="fa fa-th-list"></i>
                </div>
                <div
                  class="layout-btn btn-bars"
                  title="Bars"
                  :class="{ active: layout === 'bars' }"
                  @click="switchLayout('bars')"
                >
                  <i class="fas fa-bars"></i>
                </div>
              </div>
              <!-- End .layout-modes -->
            </div>
            <!-- End .toolbox-item -->
          </nav>
          <div class="row row-sm" v-if="articles && articles.length > 0 && layout === 'grid'">
            <div
              class="col-6 col-md-4 col-lg-3 mb-2"
              v-for="item in articles"
              :key="item.articleId"
            >
              <div class="product-default inner-quickview inner-icon bg-white h-100 mb-0">
                <figure>
                  <router-link
                    :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }"
                  >
                    <Photo
                      :src="`${baseUrl}${item.highlightedImageUrl}`"
                      v-if="item.highlightedImageUrl"
                    />
                    <Photo src="assets/images/no-image.jpg" v-else />
                  </router-link>
                  <div v-if="getCurrentDiscount(item) != '0'" class="label-group">
                    <span class="product-label label-cut">
                      {{ getCurrentDiscount(item) | percentage }}% </span>
                  </div>
                  <div v-if="!item.disableSelling || canPassRestrictions" class="btn-icon-group">
                    <button class="btn-icon btn-add-cart" @click="addToCart(item)">
                      <i class="sicon-equalizer" v-if="item.hasAttributes" />
                      <i class="icon-bag" v-else />
                    </button>
                  </div>
                  <button
                    class="btn btn-sm btn-quickview"
                    data-toggle="modal"
                    @click="getQuickArticle(item.id)"
                  >
                    {{ translations.quickPreview }}
                  </button>
                </figure>
                <div class="product-details">
                  <div class="category-wrap">
                    <div class="category-list">
                      <router-link
                        v-if="item.brandId"
                        class="product-category"
                        :to="{ name: 'Brand',
                         params: { id: item.brandId, title: item.brand.replace(/\s+/g, '-')  } }"
                      >
                        {{ item.brand }}
                      </router-link>
                      <span v-else class="product-category">
                        {{ item.brand }}
                      </span>
                    </div>
                    <a
                      href="#"
                      @click.stop.prevent="toggleWishlistItem(item.articleId)"
                      class="btn-icon-wish"
                      :class="{ active: item.isOnWishlist }"
                    >
                      <i class="icon-heart" :class="{ 'icon-heart-1': item.isOnWishList }"></i>
                    </a>
                  </div>
                  <h2 class="product-title">
                    <router-link
                      :to="{
                        name: 'Article',
                        params: { id: item.id, slug: slugify(item.title) }
                      }"
                    >
                      {{ item.title }}
                    </router-link>
                  </h2>
                  <div class="ratings-container">
                    {{ translations.forms.labels.code }}: {{ item.code }}
                    <!-- End .product-ratings -->
                  </div>
                  <!-- End .product-container -->
                  <div class="price-box" v-if="(canViewPrices && !item.disableSelling) ||
                    canPassRestrictions">
                    <span class="product-price">
                      {{ getCurrentPrice(item) | money3WithCurrency }}</span>
                    <span class="old-price" v-if="getOldPrice(item) > 0">
                      {{ getOldPrice(item) | money3 }} KM
                    </span>
                  </div>
                  <!-- End .price-box -->
                  <button
                    v-if="
                      (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero)) &&
                      !canPassRestrictions
                    "
                    class="btn btn-primary btn-sm py-2 px-0 text-center btn-block"
                    @click="showOutOfStockModal(item)"
                  >
                  {{ translations.availableOnRequest }}
                  </button>
                </div>
                <!-- End .product-details -->
              </div>
            </div>
          </div>
          <div class="row row-sm" v-if="articles && articles.length === 0">
            <div class="col-12">
              <div class="alert alert-info">
                {{ translations.noResultsAccordingToTheGivenParameters }}.
              </div>
            </div>
          </div>

          <div class="row row-sm" v-if="layout === 'list' && articles && articles.length > 0">
            <div
              class="col-6 col-sm-12 product-default left-details product-list"
              v-for="item in articles"
              :key="item.id"
            >
              <figure>
                <router-link
                  :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }"
                >
                  <img
                    :src="`${baseUrl}${item.highlightedImageUrl}`"
                    v-if="item.highlightedImageUrl"
                  />
                  <img src="assets/images/no-image.jpg" v-else />
                </router-link>
                <div
                  class="label-group"
                  v-if="getCurrentDiscount(item) != '0'"
                  style="position: absolute; top: 5px; left: 5px"
                >
                  <span class="product-label label-cut">
                    {{ getCurrentDiscount(item) | percentage }}% </span>
                </div>
              </figure>
              <div class="product-details product-details-list">
                <div class="category-list">
                  <a class="product-category">{{ item.brand }}</a>
                </div>
                <h2 class="product-title">
                  <router-link
                    :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }"
                  >
                    {{ item.title }}
                  </router-link>
                </h2>
                <div class="ratings-container">
                  {{ translations.forms.labels.code }}: {{ item.code }}
                  <!-- End .product-ratings -->
                </div>
                <!-- End .product-container -->
                <p class="product-description" v-html="item.shortDescription">
                </p>
                <div class="price-box" v-if="canViewPrices && !item.disableSelling">
                  <span class="product-price">
                    {{ getCurrentPrice(item) | money3WithCurrency }}</span>
                  <span class="old-price" v-if="getOldPrice(item)">
                    {{ getOldPrice(item) | money3 }} KM
                  </span>
                </div>
                <!-- End .price-box -->
                <div class="product-action">
                  <div class="product-single-qty product-list-quantity" v-if="!item.disableSelling">
                    <div class="input-group">
                      <span
                        class="input-group-btn input-group-prepend"
                        @click="setQuantity(item, -1)"
                      >
                        <button class="btn btn-outline btn-down-icon" type="button" />
                      </span>
                      <input
                        class="horizontal-quantity form-control"
                        v-model.number="item.quantity"
                      />
                      <span
                        class="input-group-btn input-group-append"
                        @click="setQuantity(item, 1)"
                      >
                        <button class="btn btn-outline btn-up-icon" type="button" />
                      </span>
                    </div>
                  </div>
                  <button
                    v-if="!item.disableSelling || canPassRestrictions"
                    class="btn-icon btn-add-cart"
                    @click="addToCart(item)"
                  >
                    <i class="sicon-equalizer" v-if="item.hasAttributes" />
                    <i class="icon-bag" v-else />
                    {{ item.hasAttributes ? translations.chooseOptions : translations.addToCart }}
                  </button>
                  <button
                    v-if="
                      (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero)) &&
                      !canPassRestrictions
                    "
                    class="btn-icon btn-add-cart"
                    @click="showOutOfStockModal(item)"
                  >
                  {{ translations.availableOnRequest }}
                  </button>
                  <a
                    href="#"
                    @click.stop.prevent="toggleWishlistItem(item.id)"
                    class="btn-icon-wish"
                  >
                    <i class="icon-heart"></i>
                  </a>
                  <button class="btn-quickview" @click="getQuickArticle(item.id)">
                    <i class="fas fa-external-link-alt"></i>
                  </button>
                </div>
              </div>
              <!-- End .product-details -->
            </div>
          </div>

          <div
            class="table-product-list"
            v-if="layout === 'bars' && articles && articles.length > 0"
          >
            <table class="table text-left mb-3">
              <thead>
                <tr>
                  <th>{{ translations.manufacturer }}</th>
                  <th>{{ translations.forms.labels.code }}</th>
                  <th>{{ translations.productName }}</th>
                  <th>{{ translations.preview }}</th>
                  <th v-if="canViewPrices">VP Cijena</th>
                  <th>{{ translations.discount }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in articles" :key="item.id">
                  <td>
                    {{ item.brand }}
                  </td>
                  <td>
                    {{ item.code }}
                  </td>
                  <td>
                    <router-link
                      :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }"
                    >
                      {{ item.title }}
                    </router-link>
                  </td>
                  <td>
                    <img
                      class="small-product-list-img"
                      :src="`${baseUrl}${item.highlightedImageUrl}`"
                      v-if="item.highlightedImageUrl"
                    />
                    <img class="small-product-list-img" src="assets/images/no-image.jpg" v-else />
                  </td>
                  <td v-if="canViewPrices">
                    <span v-if="item.disableSelling">N/A</span>
                    <span v-else>{{ item.price | money3WithCurrency }}</span>
                  </td>
                  <td>{{ getCurrentDiscount(item) | percentage }}%</td>
                  <td class="order-actions justify-content-end">
                    <div class="product-single-qty"
                      style="margin-top: 5px;" v-if="!item.disableSelling">
                      <div class="input-group bootstrap-touchspin">
                        <span
                          class="input-group-btn input-group-prepend"
                          @click="setQuantity(item, -1)"
                        >
                          <button class="btn btn-outline btn-down-icon" type="button" />
                        </span>
                        <input
                          class="horizontal-quantity form-control"
                          v-model.number="item.quantity"
                        />
                        <span
                          class="input-group-btn input-group-append"
                          @click="setQuantity(item, 1)"
                        >
                          <button class="btn btn-outline btn-up-icon" type="button" />
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="!item.disableSelling || canPassRestrictions"
                      class="btn-icon btn-add-cart" style="margin-top: 5px;"
                      @click="addToCart(item)"
                    >
                      <i class="sicon-equalizer" v-if="item.hasAttributes" />
                      <i class="fas fa-shopping-bag" v-else />
                    </div>
                    <div
                      v-if="
                        (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero)) &&
                        !canPassRestrictions
                      "
                      class="btn-icon"
                      role="button"
                      @click="showOutOfStockModal(item)"
                    >
                      <button class="paction add-cart">
                        {{ translations.availableOnRequest }}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination :action="actionName" :pagination-props="paginationProps" />
        </div>
        <!-- End .col-lg-9 -->
        <aside class="sidebar-shop col-lg-3 col-xl-5col-1 order-lg-first">
          <div class="sidebar-wrapper">
            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-categories"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-categories"
                  >{{ translations.categories }}</a
                >
              </h3>
              <div
                class="collapse show"
                id="widget-categories"
                v-if="searchFilters && searchFilters.categories"
              >
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                    v-for="item in searchFilters.categories"
                    :key="item.categoryId"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="item.categoryId"
                      v-model="categoryIds"
                      :id="`checkbox-${item.categoryId}`"
                    />
                    <label class="custom-control-label" :for="`checkbox-${item.categoryId}`">
                      {{ item.title }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>

            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-on-stock"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-on-stock"
                >
                {{ translations.stock }}
                </a>
              </h3>
              <div class="collapse show" id="widget-on-stock">
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="onStock"
                      :id="'checkbox-on-stock'"
                    />
                    <label class="custom-control-label" :for="'checkbox-on-stock'">
                      {{ translations.isInStock }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>

            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-brands"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-brands"
                  >{{ translations.brands }}</a
                >
              </h3>
              <div
                class="collapse show"
                id="widget-brands"
                v-if="searchFilters && searchFilters.brands"
              >
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                    v-for="item in searchFilters.brands"
                    :key="item.brandId"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="item.brandId"
                      v-model="brandIds"
                      :id="`checkbox-${item.brandId}`"
                    />
                    <label class="custom-control-label" :for="`checkbox-${item.brandId}`">
                      {{ item.title }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>
            <!-- End .widget -->
            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-body-3"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-body-3"
                >
                  {{ translations.priceRange }}
                </a>
              </h3>
              <div class="collapse show" id="widget-body-3">
                <div>
                  <div class="filter-price-action">
                    <div class="filter-price-text">
                      {{ translations.vpc }}:
                       {{ parseFloat(searchFilters.minPriceInThisCategory).toFixed(2) }} KM -
                      {{ translations.vpc }}:
                       {{ parseFloat(searchFilters.maxPriceInThisCategory).toFixed(2) }} KM
                    </div>
                    <!-- End .filter-price-text -->
                  </div>
                  <div class="d-flex">
                    <input
                      ref="priceInput0"
                      type="number"
                      class="form-control form-control-sm price-range-min"
                      v-model="priceRange[0]"
                      @keyup="handlePriceChangeOnEnter"
                      @blur="roundPrice"
                    />
                    <input
                      ref="priceInput1"
                      type="number"
                      class="form-control form-control-sm price-range-max"
                      v-model="priceRange[1]"
                      @keyup="handlePriceChangeOnEnter"
                      @blur="roundPrice"
                    />
                  </div>
                  <div class="d-flex flex-row-reverse">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="handlePriceChange"
                    >
                    {{ translations.apply }}
                    </button>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>
            <!-- End .widget -->
            <!-- <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-tags"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-tags"
                >
                  Tagovi
                </a>
              </h3>
              <div class="collapse show" id="widget-tags">
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                    v-for="item in tags"
                    :key="item.tagId"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="item.tagId"
                      v-model="tagIds"
                      :id="`checkbox-tag-${item.tagId}`"
                    />
                    <label class="custom-control-label" :for="`checkbox-tag-${item.tagId}`">
                      #{{ item.tag }}
                    </label>
                  </div>
                </div> -->
                <!-- End .widget-body -->
              <!-- </div> -->
              <!-- End .collapse -->
            <!-- </div>  -->

            <!-- End .widget -->
          </div>
          <!-- End .sidebar-wrapper -->
        </aside>
        <!-- End .col-lg-3 -->
      </div>
      <!-- End .row -->
    </div>
    <!-- End .container -->
  </div>
</template>

<script>
import 'vue-range-component/dist/vue-range-slider.css';

import config from '@/config';
import api from '@/services/api';
import slugify from '@/filters/slugify';

import Photo from '@/components/shared/Image.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';

import { translations, pager } from '@/mixins';
import Pagination from '@/components/shared/Pagination.vue';

export default {
  name: 'NewArticles',
  mixins: [translations, pager],
  components: {
    QuickPreview,
    Pagination,
    Photo,
    Modal,
  },
  data() {
    return {
      actionName: 'getNewlyAddedArticles',
      layout: 'grid', // Can be list or grid
      layouts: ['grid', 'list'],
      priceRange: [1, 100],
      categoryIds: [],
      brandIds: [],
      attributeValuesIds: [],
      selectedArticle: null,
      sortField: 1,
      tagIds: [],
      additionalArticlesIds: [],
      onStock: false,
    };
  },
  computed: {
    canPassRestrictions() {
      return this.profile?.userData?.articleAlwaysVisibleOnWeb;
    },
    paginationProps() {
      return {
        attributeValuesIds: [],
        categoryIds: this.categoryIds,
        brandIds: this.brandIds,
        pageSize: this.searchConfig.pageSize,
        minPrice: parseFloat(this.priceRange[0], 10),
        maxPrice: parseFloat(this.priceRange[1], 10),
        tagIds: this.tagIds,
        additionalArticlesIds: this.additionalArticlesIds,
        onStock: this.onStock === false ? null : true,
      };
    },
    articles() {
      return this.$store.getters.getNewlyAddedArticles;
    },
    baseUrl() {
      return config.baseUrl;
    },
    searchFilters() {
      return this.$store.getters.getNewlyAddedArticlesFilter;
    },
    category() {
      return this.$store.getters.getCategoryById(this.$route.params.id);
    },
    prices() {
      if (!this.searchFilters?.minPriceInThisCategory) return [0, 100];
      return [this.searchFilters.minPriceInThisCategory.toFixed(2),
        this.searchFilters.maxPriceInThisCategory.toFixed(2)];
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    tags() {
      return this.$store.getters.getMostPopularTags;
    },
    showAddAllButton() {
      return this.articles.some((item) => item.quantity > 0);
    },
    allowOrderingStockZero() {
      return this.$store.getters.getAllowOrderingStockZero;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  methods: {
    slugify,
    getCurrentPrice(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const baseArticlePrice = item.baseArticlePrice || 0;

      if (salePrice > 0 && salePrice < price) {
        return salePrice;
      }
      return price === 0 ? baseArticlePrice : price;
    },
    getCurrentDiscount(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;
      if (salePrice > 0 && salePrice < price) {
        return item.saleDiscountPercentage;
      }
      if (matchedPP) {
        return (100 * (1 - item.price / item.baseArticlePrice)) * -1;
      }
      return 0;
    },
    handlePriceChangeOnEnter(event) {
      if (event.key === 'Enter') {
        if (parseFloat(this.priceRange[0], 10) > parseFloat(this.priceRange[1], 10)) {
          this.priceRange[0] = this.searchFilters.minPriceInThisCategory;
        }
        this.$refs.priceInput0.blur();
        this.$refs.priceInput1.blur();
        this.paginationProps.minPrice = parseFloat(this.priceRange[0], 10);
        this.paginationProps.maxPrice = parseFloat(this.priceRange[1], 10);
        this.getArticles();
      }
    },
    roundPrice() {
      this.priceRange[0] = parseFloat(this.priceRange[0]).toFixed(2);
      this.priceRange[1] = parseFloat(this.priceRange[1]).toFixed(2);
    },
    handlePriceChange() {
      if (parseFloat(this.priceRange[0], 10) > parseFloat(this.priceRange[1], 10)) {
        this.priceRange[0] = this.searchFilters.minPriceInThisCategory;
      }
      this.paginationProps.minPrice = parseFloat(this.priceRange[0], 10);
      this.paginationProps.maxPrice = parseFloat(this.priceRange[1], 10);
      this.getArticles();
    },
    getOldPrice(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;

      if (salePrice > 0 && salePrice < price) {
        return item.baseArticlePrice === 0 || !item.baseArticlePrice
          ? item.price
          : item.baseArticlePrice;
      }
      if (matchedPP) {
        return item.baseArticlePrice;
      }
      return 0;
    },
    showOutOfStockModal(item) {
      this.$store.dispatch('showOutOfStockModal', { articleId: item.id });
    },
    getArticles() {
      this.$store.dispatch('getNewlyAddedArticles', {
        ...this.searchConfig,
        ...this.paginationProps,
      });
    },
    addSelectedToCart() {
      [...this.articles]
        .filter((item) => item.quantity > 0)
        .forEach((item) => {
          this.addToCart(item);
        });
    },
    getFilters() {
      this.$store.dispatch('getNewlyAddedArticlesFilter', {
        sortBy: 'title',
        isSortAscending: false,
        attributeValuesIds: [],
        categoryIds: [],
        brandIds: [],
      });
    },
    switchLayout(layout) {
      this.layout = layout; // 'bars';
      this.articles.map((item) => {
        // eslint-disable-next-line no-param-reassign
        item.quantity = layout === 'bars' ? 0 : 1;
        return item;
      });
    },
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.getArticles();
        this.$store.dispatch('getWishList');
      });
    },
    addToCart(item) {
      if (item.hasAttributes || (!item.stockAmount && !this.allowOrderingStockZero)) {
        this.$router.push({ name: 'Article', params: { id: item.id, slug: slugify(item.title) } });
        return;
      }

      if (this.layout === 'bars' && item.quantity <= 0) {
        return;
      }
      this.selectedArticle = item;
      api
        .addToShoppingCart({
          articleId: item.id,
          quantity: item.quantity || 1,
        })
        .then(() => {
          if (this.layout !== 'bars') {
            $('#addCartModal').modal('show');
          } else {
            this.$toast.info(this.translations.itemAddedToCart);
          }
          this.$store.dispatch('getShoppingCart');
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getShoppingCart');
          $('#addCartModal').modal('hide');
        });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        this.$store.dispatch('getArticleVariations', articleId).then(() => {
          this.$store.dispatch('getAttributes', { retrieveAll: true });
          $('#quick-preview-article').modal('show');
        });
      });
    },
    handleSortChange() {
      const field = this.sortFields.find((i) => i.id === this.sortField);
      this.handleSort(field);
    },
    setQuantity(item, num) {
      if (item.quantity <= 0 && num === -1) return;
      // eslint-disable-next-line no-param-reassign
      item.quantity += num;
    },
    handleScroll() {
      localStorage.setItem('newArticlesScrollPosition', window.scrollY);
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.addEventListener('scroll', this.handleScroll);
    this.getFilters();
    this.$store.dispatch('getMostPopularTags');
    this.roundPrice();
  },
  watch: {
    tagIds() {
      this.getArticles();
    },
    brandIds() {
      this.getArticles();
    },
    attributeValuesIds() {
      this.getArticles();
    },
    categoryIds() {
      this.getArticles();
    },
    articles() {
      if (this.articles.length === 20) {
        this.additionalArticlesIds = this.articles.map((article) => article.id);
      }
    },
    prices() {
      this.priceRange = this.prices;
    },
    searchFilters() {
      this.priceRange = this.prices;
      this.getArticles();
    },
    onStock() {
      this.paginationProps.onStock = this.onStock === false ? null : true;
      this.getArticles();
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.product-default .product-title {
  display: block;
  width: 100%;
}

.product-list .product-details {
  width: calc(100% - 270px);
}

.category-checkbox {
  margin-top: 0;
  margin-bottom: 1rem;
}

.custom-color-label {
  width: 20px;
  height: 20px;
  background: black;
}

.custom-color-label {
  width: 6rem;
  height: 2rem;
}

.layout-btn {
  cursor: pointer;
}

.order-actions {
  display: flex;
  border-top: none !important;
  margin-top: 5px;
  margin-bottom: 5px;

  .product-single-qty {
    max-width: unset;
    max-height: unset;
  }

  .product-single-qty .bootstrap-touchspin.input-group {
    max-height: 30px;
  }

  .product-single-qty .bootstrap-touchspin .form-control {
    max-height: 30px;
  }

  i {
    color: #1e84bc;
    font-size: 1.7rem;
    margin-right: 1.5rem;
    padding-left: 5px;
  }

  .btn-icon.btn-add-cart {
    display: inline-block;
    padding-top: 5px;
    line-height: 1;
    height: 20px;
    margin-left: 10px;
  }
}

.btn-add-cart.hidden {
  opacity: 0.5;
}

.product-list-quantity {
  height: 37px;
  margin-bottom: 5px;
  margin-right: 5px;

  .horizontal-quantity {
    height: 37px;
  }
}

.html-content a {
  color: #3598DB;
}
</style>
